import { Component, OnInit } from '@angular/core';
import { Icons } from '../../../../shared/helpers/icons';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { LucideAngularModule } from 'lucide-angular';
import { AssessmentInfoComponent } from "./assessment-info/assessment-info.component";
import { ThreatBackgroundComponent } from "./threat-background/threat-background.component";
import { SectionAComponent } from './section-a/section-a.component';
import { SectionBComponent } from './section-b/section-b.component';
import { SectionCComponent } from "./section-c/section-c.component";
import { SectionDComponent } from './section-d/section-d.component';
import { SectionEComponent } from './section-e/section-e.component';
import { SectionFComponent } from './section-f/section-f.component';
import { SectionGComponent } from "./section-g/section-g.component";
import { SectionHComponent } from './section-h/section-h.component';
import { SectionIComponent } from "./section-i/section-i.component";
import { SectionJComponent } from './section-j/section-j.component';
import { SectionKComponent } from './section-k/section-k.component';
import { SectionMComponent } from "./section-m/section-m.component";
import { SectionLComponent } from './section-l/section-l.component';
import { SectionNComponent } from './section-n/section-n.component';
import { FullTeamAssessmentService } from '../../../../shared/services/fullTeamAssessment.service';
import { IFullTeamAssessment } from '../../../../shared/models/fullTeamAssessment';
import { UserDataService } from '../../../../shared/services/auth/userData.service';
import { SpinnerComponent } from '../../../components/spinner/spinner.component';
import { PopupMessageComponent } from '../../../components/popup-message/popup-message.component';
import { FullTeamOfficialSignatureComponent } from './full-team-official-signature/full-team-official-signature.component';
import { FullTeamSubmissionComponent } from './full-team-submission/full-team-submission.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-full-team-threat-assessment',
  standalone: true,
  imports: [
    CommonModule,
    LucideAngularModule,
    AssessmentInfoComponent,
    ThreatBackgroundComponent,
    SectionAComponent,
    SectionBComponent,
    SectionCComponent,
    SectionDComponent,
    SectionEComponent,
    SectionFComponent,
    SectionGComponent,
    SectionHComponent,
    SectionIComponent,
    SectionJComponent,
    SectionKComponent,
    SectionLComponent,
    SectionMComponent,
    SectionNComponent,
    FullTeamOfficialSignatureComponent,
    FullTeamSubmissionComponent,
    SpinnerComponent,
    PopupMessageComponent
],
  templateUrl: './full-team-threat-assessment.component.html',
  styleUrl: './full-team-threat-assessment.component.css'
})
export class FullTeamThreatAssessmentComponent implements OnInit {

  icons = Icons;
  currentBuildingId: string | null = null;

  currentCaseId: string | null = null;
  currentFullTeamAssessment: any | null = null;
  stepsConfig = [
    {
      id: 1,
      completionProperty: 'assessment_info_completion',
      nextStepDependency: null
    },
    {
      id: 2,
      completionProperty: 'threat_background_completion',
      nextStepDependency: 'assessment_info_completion'
    },
    {
      id: 3,
      completionProperty: 'section_a_completion',
      nextStepDependency: 'threat_background_completion'
    },
    {
      id: 4,
      completionProperty: 'section_b_completion',
      nextStepDependency: 'section_a_completion'
    },
    {
      id: 5,
      completionProperty: 'section_c_completion',
      nextStepDependency: 'section_b_completion'
    },
    {
      id: 6,
      completionProperty: 'section_d_completion',
      nextStepDependency: 'section_c_completion'
    },
    {
      id: 7,
      completionProperty: 'section_e_completion',
      nextStepDependency: 'section_d_completion'
    },
    {
      id: 8,
      completionProperty: 'section_f_completion',
      nextStepDependency: 'section_e_completion'
    },
    {
      id: 9,
      completionProperty: 'section_g_completion',
      nextStepDependency: 'section_f_completion'
    },
    {
      id: 10,
      completionProperty: 'section_h_completion',
      nextStepDependency: 'section_g_completion'
    },
    {
      id: 11,
      completionProperty: 'section_i_completion',
      nextStepDependency: 'section_h_completion'
    },
    {
      id: 12,
      completionProperty: 'section_j_completion',
      nextStepDependency: 'section_i_completion'
    },
    {
      id: 13,
      completionProperty: 'section_k_completion',
      nextStepDependency: 'section_j_completion'
    },
    {
      id: 14,
      completionProperty: 'section_l_completion',
      nextStepDependency: 'section_k_completion'
    },
    {
      id: 15,
      completionProperty: 'section_m_completion',
      nextStepDependency: 'section_l_completion'
    },
    {
      id: 16,
      completionProperty: 'section_n_completion',
      nextStepDependency: 'section_m_completion'
    },
    {
      id: 17,
      completionProperty: 'official_signature_completion',
      nextStepDependency: 'section_n_completion'
    }
  ];
  finalStepConfig = {
      id: 18,
      completionProperty: 'full_team_threat_assessment_completion',
      nextStepDependency: 'official_signature_completion'
  };
  currentStep: number = 1;
  tooltips = ['Assessment Information', 'Threat Background', 'Section A', 'Section B', 'Section C', 'Section D', 'Section E', 'Section F', 'Section G', 'Section H', 'Section I', 'Section J', 'Section K', 'Section L', 'Section M', 'Section N', 'Official Signature', 'Submission'];
  messageModal: string | null = null;
  popupMessage: string | null = null;

  loading: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fullTeamAssessmentService: FullTeamAssessmentService,
    private userDataService: UserDataService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.currentBuildingId = this.userDataService.getBuildingId();
    
    this.route.paramMap.subscribe((params) => {
      this.currentCaseId = params.get('caseId');
    });
    
    this.loadFullTeamThreatAssessment();
  }

  loadFullTeamThreatAssessment(): void {
    if (this.currentCaseId) {
      this.loading = true;
      this.fullTeamAssessmentService.getFullTeamAssessmentByCaseId(this.currentCaseId).subscribe({
        next: (response) => {
          this.currentFullTeamAssessment = response;
          this.loading = false;
          return
        },
        error: (error) => {
          this.loading = false;
          console.error('Error:', error);
          this.messageModal = 'unsuccess';
          this.popupMessage = error.message;  
        }
      });
    }
  }

  handleUpdateFullTeamAssessment(data: IFullTeamAssessment, section: number): void {
    if (this.currentCaseId && this.currentBuildingId) {
      this.loading = true;
      const fullData = data;
      fullData.case_id = this.currentCaseId!;
      fullData.section = section;
      fullData.building_id = Number(this.currentBuildingId);
      this.fullTeamAssessmentService.updateFullTeamAssessment(fullData).subscribe({
        next: (response) => {
          this.loading = false;
          this.loadFullTeamThreatAssessment();
          this.toastr.success('Saved successful!', 'Success');
          this.currentStep = this.currentStep != this.finalStepConfig.id ? section + 1 : this.currentStep;
          if (section == 18 ) {
            this.router.navigate(['/assessments/']);
          }
        },
        error: (error) => {
          this.loading = false;
          this.toastr.error(error.message, 'Error'); 
        }
      });
    }
  }

  onBack(): void {
    this.router.navigate(['/assessments/']);
  }

  // move to next section
  goToStep(stepId: number): void {
    if (this.canMoveToStep(stepId)) {
      this.currentStep = stepId;
    } else {
      console.error('You must complete the required steps before proceeding.');
    }
  }
  // check if they already completed the required step before allowing them to move to the next step
  canMoveToStep(stepId: number): boolean {
    let stepConfig;
    if (stepId === this.finalStepConfig.id) {
      stepConfig = this.finalStepConfig; // Handle the final step separately
    } else {
      stepConfig = this.stepsConfig.find(step => step.id === stepId);
    }
  
    if (!stepConfig) {
      console.error('Step configuration not found for step', stepId);
      return false;
    }
  
    if (stepConfig.nextStepDependency && this.currentFullTeamAssessment) {
      return this.currentFullTeamAssessment?.[stepConfig.nextStepDependency] === 1;
    }
  
    return true;
  }

  resetMessageModal(): void {
    this.messageModal = null;
    this.popupMessage = null;
  }
}
